import { render, staticRenderFns } from "./FInfoINR.vue?vue&type=template&id=12e7b870&"
import script from "./FInfoINR.vue?vue&type=script&lang=ts&"
export * from "./FInfoINR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports